module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0167.jpg?v=6375975e";